import React from 'react';

import cx from 'classnames';
import { format } from 'date-fns';

import Icon from 'components/shared/Icon';
import UpdateDate from 'components/shared/Icon/icons/UpdateDate';
import Tooltip, { TooltipText, VARIANTS } from 'components/shared/Tooltip';
import Text from 'components/shared/Typography/Text';
import WithDatePicker from 'components/shared/WithDatePicker';
import { getLocalDateFromString } from 'utils/date';

import { updateStartDate } from '../Event/ModalContents/UpdateStartDate/functions';
import s from './index.module.css';
import { IChooseStartDateProps } from './types';

export const ChooseStartDate = ({ value, isDisabled }: IChooseStartDateProps) => {
  const minDate = value && format(getLocalDateFromString(value), 'MMMM d, yyyy');

  return (
    <>
      <WithDatePicker position="BOTTOM_CENTER" value={value} onChange={updateStartDate} isDisabled={isDisabled}>
        <div data-tip="" data-for={'updateStartDate'} className={cx(s.wrapper, isDisabled && s.disabled)}>
          <Icon component={UpdateDate} width="24px" height="24px" fill="none" />
          <Text className={s.text}>
            Start Date: <span className={s.date}>{minDate ?? 'No Date'}</span>
          </Text>
        </div>
      </WithDatePicker>
      <Tooltip variant={VARIANTS.DARK} className={s.tooltip} id="updateStartDate" disable={!isDisabled}>
        <TooltipText className={s.tooltipText}>Start by adding an event</TooltipText>
      </Tooltip>
    </>
  );
};
